import { SetStateAction, useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FlowBuilder2PageViewNameEnum } from '../Context/FlowBuilder2PageContext.types';

const PREVIEW_SEARCH_PARAM_KEY = 'preview';

export const useActiveView = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeView = useMemo<FlowBuilder2PageViewNameEnum>(() => {
    if (searchParams.get(PREVIEW_SEARCH_PARAM_KEY) === 'true')
      return FlowBuilder2PageViewNameEnum.Preview;
    return FlowBuilder2PageViewNameEnum.Builder;
  }, [searchParams]);

  const setActiveView = useCallback(
    (value: SetStateAction<FlowBuilder2PageViewNameEnum>) => {
      const viewName = typeof value === 'function' ? value(activeView) : value;

      switch (viewName) {
        case FlowBuilder2PageViewNameEnum.Preview:
          searchParams.set(PREVIEW_SEARCH_PARAM_KEY, 'true');
          setSearchParams(searchParams, { replace: true });
          break;

        case FlowBuilder2PageViewNameEnum.Builder:
        default:
          searchParams.delete(PREVIEW_SEARCH_PARAM_KEY);
          setSearchParams(searchParams, { replace: true });
          break;
      }
    },
    [activeView, searchParams, setSearchParams],
  );

  return [activeView, setActiveView] as const;
};
